require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-lucy-lofthouse.json") })
        }
      }, "path---authors-lucy-lofthouse");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-lucy-lofthouse!./.cache/json/authors-lucy-lofthouse.json
// module id = 1307
// module chunks = 231608221292675